import { Environment } from '../app/core/models/environment.model';

export const environment: Environment = {
  production: false,
  apiUrls: {
    identity: '/identity',
    notification: '/notification-api',
    bffAdmin: '/bff-admin-api',
  },
  auth: {
    issuer: 'https://qa.redrock.pro/identity',
    redirectUri: 'https://admin-qa.redrock.pro/login/confirmation',
    clientId: 'admin_panel',
    dummyClientSecret: 'admin_secret_rrp_240913',
    responseType: 'code',
    scope: 'openid admin_panel_api identity_api offline_access',
    tokenEndpoint: 'https://qa.redrock.pro/identity/connect/token',
    logoutUrl: 'https://qa.redrock.pro/identity/logout',
    postLogoutRedirectUri: 'https://admin-qa.redrock.pro',
    requireHttps: false,
  },
  registrationUrl: 'https://qa.redrock.pro/identity/registration',
  poolUrl: 'https://qa.redrock.pro',
  observerLink: 'https://qa.redrock.pro/observer/',
};
